const Routes = Object.freeze({
  ROOT: "/",
  LOGIN: "login",
  LOGOUT: "logout",
  PATIENTS: "patients/",
  SEARCH_PROGRAMS: "search-programs",
  CALLBACK: "/callback",
  PATIENT: "patient/",
  UPLOADER: "/uploader",
  SEARCH_RESULTS: "/search-results",
  RECENT_PATIENTS: "/recent-patients",
  NEW_PATIENT: "/new-patient",
  FILTER_LIST: "/savedLists",
  CLAIMS: "claims",
  NEW_CLAIM: "new",
  EDIT_CLAIM: "edit",
  DUPLICATE_CLAIM: "duplicate",
  ORDER: "order",
  ONLINE_WIZARD: "/online-wizard",
  TOP_OPPORTUNITIES: "top-opportunities/",
  SETTINGS: "/settings",
  NOTIFICATION_PREFERENCES: "/notification-preferences",
  PHYSICIANS_SETTINGS: "/physicians-settings",

  PATIENT_APPLICATION_PATH: ({ patientId, journeyId, papId, applicationId }) =>
    `/patient/${patientId}/journey/${journeyId}/applications/${papId}/${applicationId}`,

  PATIENT_PATH: ({ patientId }) => `/patient/${patientId}`,

  PATIENT_JOURNEY_PATH: ({ patientId, journeyId }) => `/patient/${patientId}/journey/${journeyId}`
});

export { Routes };
